<template>
    <v-dialog v-model="modalProp" max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            >
                Account Validation
            </v-card-title>

            <v-card-text
                class="my-5 text-center"
            >
                If this is not you, you may exit the app. If you have concern with
                registration please call
                <span class="font-weight-black">HMI (02) 8811-1313</span>. Thank
                you!
            </v-card-text>
            <v-card-actions>
                <v-spacer />

                <v-btn
                    color="red darken-1"
                    text
                    @click="modalProp = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['noDialog'],
    data: () => ({}),
    computed: {
        modalProp: {
            get() {
                return this.noDialog
            },
            set(val) {
                this.$emit('pop-noDialog', val)
            }
        }
    }
}
</script>

<style></style>
